import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { VIEW, EDIT, YES } from "const"
import {
    StoreType,
    setRrsTemplateBaseRoute,
} from "client/store"
import {
    projectsRoute,
    projectBaseRoute,
    rrsTemplatesRoute,
} from "client/parts/routes"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"
import TemplateView from "./templateView"
import TemplateEdit from "./templateEdit"
import TemplateList from "./templateList"

const RrsTemplate = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const dispatch = useDispatch()

    const { rrsRiskSpaceModuleAccess } = packageSettings
    const access = userData.accountId === 1 || rrsRiskSpaceModuleAccess === YES

    const baseRouteMask = project.id ? `${projectBaseRoute}${rrsTemplatesRoute}` : rrsTemplatesRoute
    const baseRoute = project.id ? `${projectsRoute}/${VIEW}/${project.id}${rrsTemplatesRoute}` : rrsTemplatesRoute

    useEffect(() => {
        dispatch(setRrsTemplateBaseRoute(baseRoute))
    }, [])

    if (!access) return <AccessDenied />
    return (
        <Switch>
            <Route
                path={`${baseRouteMask}/${VIEW}/:templateId`}
                component={TemplateView}
            />
            <Route
                path={`${baseRouteMask}/${EDIT}/:templateId`}
                component={TemplateEdit}
            />
            <Route
                path={baseRouteMask}
                component={TemplateList}
            />
        </Switch>
    )
}
export default RrsTemplate
